import React from "react";

/**
 * Logo Frente Ya — palabra "FRENTE" + "YA" con subrayado azul/celeste
 * y flecha amarilla hacia arriba a la derecha (sin círculo).
 */
export const LogoMark = ({ className = "h-12", variant = "dark" }) => {
  const textColor = variant === "light" ? "#FFFFFF" : "#0A192F";

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <span
        className="font-headings font-bold tracking-tight text-[1.85rem] sm:text-[2.1rem] leading-none"
        style={{ color: textColor }}
      >
        FRENTE
      </span>

      {/* Bloque YA + subrayado azul + flecha amarilla */}
      <div className="relative inline-flex items-start leading-none">
        <span
          className="font-headings font-bold tracking-tight text-[1.85rem] sm:text-[2.1rem] leading-none relative"
          style={{ color: textColor }}
        >
          YA
          {/* línea azul/celeste de base */}
          <span
            aria-hidden
            className="absolute left-0 right-0 -bottom-1 h-[5px] bg-[#2563EB]"
          />
        </span>
        {/* Flecha amarilla hacia arriba */}
        <svg
          viewBox="0 0 22 60"
          width="14"
          height="38"
          className="ml-1 -mt-1 self-start"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <polygon points="0,14 22,14 11,0" fill="#F5B400" />
          <rect x="6" y="13" width="10" height="45" fill="#F5B400" />
        </svg>
      </div>
    </div>
  );
};

export default LogoMark;
